<template>
    <div id="mobile-menu" class="mobile-menu" v-if="localIsShow">
        <div class="mobile-menu_inner">
          <div class="mobile-menu_gnb-wrap">
            <ul class="mobile-menu_list">
              <li class="mobile-menu_menu has-child">
                <a class="mobile-menu_link"  @click="toggleNav('navShow')">사업</a>
                <div class="sub-nav" :class="{ nav: navShow }">
                  <ul class="sub-nav_list">
                    <li class="sub-nav_menu">
                      <router-link to="/hospital" class="sub-nav_link"
                        >병원진료</router-link
                      >
                    </li>
                    <li class="sub-nav_menu">
                      <router-link to="/move" class="sub-nav_link"
                        >이동진료</router-link
                      >
                    </li>
                    <li class="sub-nav_menu">
                      <router-link to="/salvation" class="sub-nav_link"
                        >구제사역</router-link
                      >
                    </li>
                    <li class="sub-nav_menu">
                      <router-link to="/edu" class="sub-nav_link"
                        >의료인교육</router-link
                      >
                    </li>
                  </ul>
                </div>
              </li>
              <li class="mobile-menu_menu has-child">
                <a class="mobile-menu_link"  @click="toggleNav('navShow2')">활동</a>
                <div class="sub-nav" :class="{ nav: navShow2 }">
                  <ul class="sub-nav_list">
                    <li class="sub-nav_menu">
                      <router-link to="/news" class="sub-nav_link"
                        >활동게시판</router-link
                      >
                    </li>
                    <li class="sub-nav_menu">
                      <router-link to="/notice" class="sub-nav_link"
                        >공지사항</router-link
                      >
                    </li>
                  </ul>
                </div>
              </li>
              <li class="mobile-menu_menu has-child">
                <a class="mobile-menu_link"  @click="toggleNav('navShow3')">후원</a>
                <div class="sub-nav" :class="{ nav: navShow3 }">
                  <ul class="sub-nav_list">
                      <li class="sub-nav_menu">
                        <button class="sub-nav_link" @click="opendonation()" style="background: transparent; border: 0">월드휴먼브리지</button>
                      </li>
                      <li class="sub-nav_menu">
                        <div class="sub-nav_link hover" v-on:click="toggleMissionFundSubMenu" style="background: transparent; border: 0">미션 펀드</div>
                        <div v-show="showMissionFund" class="sub-nav_content" style="text-align:left; margin-left:50px">
                          <!-- 미션 펀드에 대한 하위 메뉴 내용 -->
                          <ul>
                            <li>
                              <button class="sub-nav_link" @click="opendonation3()" style="background: transparent; border: 0;margin-top:7px;margin-left:50px">혈액투석후원</button>
                            </li>
                            <li>
                              <button class="sub-nav_link" @click="opendonation4()" style="background: transparent; border: 0;margin-top:7px;margin-left:50px">병원신축후원</button>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li class="sub-nav_menu">
                        <div class="sub-nav_link hover" v-on:click="toggleReceiptSubMenu" style="background: transparent; border: 0">기부영수증</div>
                        <div v-show="showReceipt" class="sub-nav_content" style="text-align:left; margin-left:50px">
                          <!-- 기부영수증에 대한 하위 메뉴 내용 -->
                          <ul>
                            <li>
                              <button class="sub-nav_link" @click="opendonation5()" style="background: transparent; border: 0;margin-top:7px;margin-left:50px">월드휴먼브리지</button>
                            </li>
                            <li>
                              <button class="sub-nav_link" @click="opendonation6()" style="background: transparent; border: 0;margin-top:7px;margin-left:50px">미션펀드</button>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                </div>
              </li>
              <li class="mobile-menu_menu has-child">
                <a class="mobile-menu_link"  @click="toggleNav('navShow4')">아가페</a>
                <div class="sub-nav" :class="{ nav: navShow4 }">
                  <ul class="sub-nav_list">
                    <li class="sub-nav_menu">
                      <router-link to="/greeting" class="sub-nav_link"
                        >인사말</router-link
                      >
                    </li>
                    <li class="sub-nav_menu">
                      <router-link to="/history" class="sub-nav_link">병원연혁</router-link>
                    </li>
                    <!-- <li class="sub-nav_menu">
                      <router-link to="/doctors" class="sub-nav_link">의료진</router-link>
                    </li> -->
                  </ul>
                </div>
              </li>
              <li
                class="mobile-menu_menu has-child"
                style="display: flex; justify-content: center"
              >
                <div class="donation_button">
                  <button class="gnb_link button" @click="opendonation()">바로후원</button>
                </div>
              </li>
              <li class="mobile-menu_menu has-child">
                <button
                  @click="openfacebook()"
                  style="border: 0; background: transparent"
                >
                  <img src="../assets/facebook.png" style="height: 25px" />
                </button>
              </li>
            </ul>
          </div>
          <div class="language-wrap">
            <ul class="language-list">
              <li class="language-item active">
                <a class="language-link">KR</a>
              </li>
              <li class="language-item">
                    <a class="language-link">EN</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
</template>

<script>
import '../assets/css/common.css'

export default {
  props: {
    localIsShow: Boolean,
  },
  data() {
    return {
      navShow: false,
      navShow2: false,
      navShow3: false,
      navShow4: false,
      showMissionFund: false, // 추가
      showReceipt: false, // 추가
    };
  },
  methods: {
    toggleNav(navVariable) {
      // Toggle the value of the specified navVariable
      this[navVariable] = !this[navVariable];
    },
    openfacebook() {
      window.location.href = 'https://www.facebook.com/agapechristianhospital/?mibextid=LQQJ4d';
    },
    opendonation() {
      window.location.href = 'https://whb.or.kr/140';
    },
    opendonation3() {
      window.location.href = 'https://go.missionfund.org/ach30000';
    },
    opendonation4() {
      window.location.href = 'https://go.missionfund.org/achnew';
    },
    opendonation5() {
      window.location.href = 'https://www.whb.or.kr/34/?q=YToxOntzOjEyOiJrZXl3b3JkX3R5cGUiO3M6MzoiYWxsIjt9&bmode=view&idx=15969704&t=board';
    },
    opendonation6() {
      window.location.href = 'https://missionfund.org/receipt/';
    },
    openreceipt() {
      window.location.href = 'https://www.whb.or.kr/34/?q=YToxOntzOjEyOiJrZXl3b3JkX3R5cGUiO3M6MzoiYWxsIjt9&bmode=view&idx=15969704&t=board';
    },   
    showMissionFundSubMenu() {
      this.showMissionFund = true;
    },
    hideMissionFundSubMenu() {
      this.showMissionFund = false;
    },
    showReceiptSubMenu() {
      this.showReceipt = true;
    },
    hideReceiptSubMenu() {
      this.showReceipt = false;
    },
    toggleMissionFundSubMenu() {
    this.showMissionFund = !this.showMissionFund;
    this.showReceipt = false; // Close the receipt sub-menu if open
  },
  toggleReceiptSubMenu() {
    this.showReceipt = !this.showReceipt;
    this.showMissionFund = false; // Close the mission fund sub-menu if open
  },
  beforeRouteLeave() {
    clearInterval(this.intervalId)
  },
  },
  mounted() {
    // ...
  },
};
</script>

<style>
@import '../assets/css/style.css';
</style>